<div class="container-fluid">
  <div class="row" id="supervisorBehaviorsButtons">
    <div class="d-flex flex-row gap-3 ms-3 me-3">
      <button
        (click)="addBehaviorButtonClicked()"
        class="side-menu-button2 w-100"
        id="addBehaviorButton"
      >
        + Behavior
      </button>
    </div>
  </div>

  <p-table
    [value]="filteredBehaviors()"
    #dt
    id="behaviors"
    dataKey="ID"
    [tableStyle]="{ width: '100%' }"
    [loading]="loadingBehaviors()"
    [rows]="25"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="true"
    [totalRecords]="getTotalBehaviorsCount()"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first}-{last} of {totalRecords} items"
    paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
    [responsive]="true"
    [resizableColumns]="true"
    styleClass="p-datatable-sm"
    [scrollable]="true"
    [scrollHeight]="'flex'"
  >
    <ng-template pTemplate="caption">
      <div class="container text-center">
        <!-- Search Row -->
        <div class="row mb-3">
          <div class="col">
            <span class="p-input-icon-left w-100">
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                class="w-100"
                placeholder="Behavior Name"
                id="searchBarInput"
                (ngModelChange)="exitEditModeIfActive()"
                [(ngModel)]="searchKeyword"
              />
            </span>
          </div>
        </div>

        <!-- Collapsible Filters Row -->
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex align-items-center">
              <button
                id="toggleFiltersButton"
                type="button"
                class="btn btn-link p-0 me-2"
                (click)="toggleFiltersCollapsed()"
                [attr.aria-expanded]="!filtersCollapsed()"
                aria-controls="filtersCollapse"
                style="font-size: 1.2rem; font-weight: bold; color: #719eb6; text-decoration: none;"
              >
                <i class="pi" [class.pi-chevron-right]="filtersCollapsed()" [class.pi-chevron-down]="!filtersCollapsed()"></i>
                Filters
              </button>
            </div>
            
            <div class="collapse" [class.show]="!filtersCollapsed()" id="filtersCollapse">
              <div class="row mt-3">
                <div class="col-auto">
                    <label for="modeAvailability" class="my-2 me-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Mode Availability: </label>
                    <p-dropdown inputId="modeAvailability" [options]="modeAvailabilityOptions" [(ngModel)]="selectedAvailabilityMode"
                      optionLabel="label" optionValue="value" [showClear]="true" appendTo="body"
                      placeholder="All" (onChange)="exitEditModeIfActive()" [style]="{minWidth: '12rem'}" />
                  </div>
                <div class="col">
                  <p-multiSelect
                    appendTo="body"
                    [group]="true"
                    [options]="possibleFilters()"
                    name="selectedFilters"
                    [(ngModel)]="selectedFilters"
                    display="chip"
                    [showClear]="true"
                    placeholder="Select Filters"
                    [style]="{ width: '100%' }"
                  >
                  </p-multiSelect>
                </div>
              </div>

              <div class="row mb-3 mt-3">
                <div class="col-12">
                  <div class="d-flex flex-wrap gap-3 justify-content-end">
      
                  @if(!includeDeleted()) {
                  <p-button
                    id="includeDeletedButton"
                    [style]="{
                      color: 'red',
                      backgroundColor: 'white',
                      border: '2px solid red',
                      'border-radius': '10px'
                    }"
                    label="Include Deleted"
                    icon="pi pi-trash"
                    (onClick)="toggleIncludeDeleted()"
                  />
                  } @else {
                  <p-button
                    [style]="{
                      color: 'white',
                      backgroundColor: 'red',
                      border: '2px solid white',
                      'border-radius': '10px'
                    }"
                    label="Exclude Deleted"
                    icon="pi pi-trash"
                    (onClick)="toggleIncludeDeleted()"
                  />
                  }
                  @if(!includeArchived()) {
                    <p-button
                      [style]="{
                        color: '#ffc107',
                        backgroundColor: 'white',
                        border: '2px solid #ffc107',
                        'border-radius': '10px'
                      }"
                      label="Include Archived"
                      icon="pi pi-trash"
                      (onClick)="toggleIncludeArchived()"
                    />
                    } @else {
                    <p-button
                      [style]="{
                        color: 'white',
                        backgroundColor: '#ffc107',
                        border: '2px solid white',
                        'border-radius': '10px'
                      }"
                      label="Exclude Archived"
                      icon="pi pi-trash"
                      (onClick)="toggleIncludeArchived()"
                    />
                    }
                    @if(!includeClosed() && !includeMastered()) {
                      <p-button
                        [style]="{
                          color: 'rgb(104, 161, 183)',
                          backgroundColor: 'white',
                          border: '2px solid rgb(104, 161, 183)',
                          'border-radius': '10px'
                        }"
                        label="Include Closed/Mastered"
                        icon="pi pi-trash"
                        (onClick)="toggleIncludeClosedAndMastered()"
                      />
                      } @else {
                      <p-button
                        [style]="{
                          color: 'white',
                          backgroundColor: 'rgb(104, 161, 183)',
                          border: '2px solid white',
                          'border-radius': '10px'
                        }"
                        label="Exclude Closed/Mastered"
                        icon="pi pi-trash"
                        (onClick)="toggleIncludeClosedAndMastered()"
                      />
                      }
                    <p-button
                      label="Clear"
                      [style]="{
                        'border-radius': '10px',
                        border: '2px solid #719eb6'
                      }"
                      icon="pi pi-filter-slash"
                      (click)="clearSearch()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Order and Selection Row -->
        <div class="row mb-3">
          <div class="col-5">
            <div class="d-flex flex-wrap gap-3 align-items-center">
              <!-- Edit/Done button (only shown when custom order is selected) -->
              @if(orderMode() === 'custom') {
              <p-button
                [label]="isEditMode() ? 'Save' : 'Edit'"
                [icon]="isEditMode() ? 'pi pi-check' : 'pi pi-pencil'"
                [style]="{
                  'border-radius': '10px',
                  border: '2px solid #28a745',
                  color: isEditMode() ? 'white' : '#28a745',
                  backgroundColor: isEditMode() ? '#28a745' : 'white'
                }"
                (onClick)="toggleEditMode()"
              />
              }
              
              <!-- Order dropdown -->
              <div class="d-flex align-items-center gap-2">
                <label style="font-size: 1rem; font-weight: bold; color: #719eb6; margin: 0;">Order:</label>
                <p-dropdown
                  [options]="orderOptions()"
                  [(ngModel)]="orderMode"
                  (ngModelChange)="onOrderModeChange()"
                  optionLabel="label"
                  optionValue="value"
                  [style]="{
                    'min-width': '150px',
                    'border-radius': '10px'
                  }"
                />
              </div>
            </div>
          </div>
          <div class="col-7">
            <div class="d-flex flex-wrap gap-3 justify-content-end">
              @if(!selectingForDeletion){
              <p-button
                label="Select Behaviors"
                [style]="{
                  backgroundColor: 'white',
                  color:'#719eb6',
                  'border-radius': '10px',
                  border: '2px solid #719eb6'
                }"
                icon="pi pi-wrench"
                (click)="toggleIsSelecting()"
              />
              }
              @else {
              <p-button
                label="Select All"
                [style]="{
                  backgroundColor: 'white',
                  color:'#719eb6',
                  'border-radius': '10px',
                  border: '2px solid #808080'
                }"
                icon="pi pi-check-square"
                (click)="selectAllBehaviors()"
              />
              <p-button
                [style]="{
                  color: 'red',
                  backgroundColor: 'white',
                  border: '2px solid red',
                  'border-radius': '10px'
                }"
                label="Delete Behaviors"
                icon="pi pi-trash"
                [disabled]="behaviorIDsForDeletion.length === 0"
                (onClick)="deleteSelectedBehaviors()"
              />
              <p-button
                label="Cancel"
                [style]="{
                  backgroundColor: 'white',
                  color:'#719eb6',
                  'border-radius': '10px',
                  border: '2px solid #808080'
                }"
                icon="pi pi-minus-circle"
                (click)="cancelIsSelecting()"
              />
              }
            </div>
          </div>
        </div>

      </div>
    </ng-template>
    <ng-template pTemplate="body" let-behavior>
      @if(orderMode() === 'custom' && isEditMode()) {
      <!-- Edit mode with overlay -->
      <tr class="edit-row">
        <td colspan="100%" class="p-0">
          <div class="edit-container" [id]="'edit-container-' + behavior.ID">
            <!-- Behavior content -->
            <div class="behavior-content">
              <app-behavior
                [behavior]="behavior"
                [id]="behavior.PatientBehaviorName"
                [isExpanded]="isExpandedStatus[behavior.ID]"
                (isExpandedChange)="onBehaviorExpandedChange(behavior.ID, $event)"
                [orderMode]="orderMode()"
                [isEditMode]="isEditMode()"
                (moveUp)="moveBehaviorUp($event)"
                (moveDown)="moveBehaviorDown($event)"
                (moveToTop)="moveBehaviorToTop($event)"
                (moveToBottom)="moveBehaviorToBottom($event)"
                [isSelecting]="selectingForDeletion"
                [selectAll]="doSelectAll"
                (selectBehavior)="selectBehavior($event)"
              />
            </div>
            
            <!-- Semi-transparent overlay with arrows -->
            <div class="arrow-overlay" [class.moved]="hasPendingChanges(behavior.ID!)">
              <div class="arrow-row">
                <button 
                  type="button" 
                  class="btn btn-sm arrow-btn"
                  (click)="moveBehaviorToTop(behavior.ID!)"
                  [disabled]="isFirstBehavior(behavior.ID!)"
                  title="Move to top">
                  <i class="pi pi-angle-double-up"></i>
                </button>
                <button 
                  type="button" 
                  class="btn btn-sm arrow-btn"
                  (click)="moveBehaviorUp(behavior.ID!)"
                  [disabled]="isFirstBehavior(behavior.ID!)"
                  title="Move up one">
                  <i class="pi pi-angle-up"></i>
                </button>
                <button 
                  type="button" 
                  class="btn btn-sm arrow-btn"
                  (click)="moveBehaviorDown(behavior.ID!)"
                  [disabled]="isLastBehavior(behavior.ID!)"
                  title="Move down one">
                  <i class="pi pi-angle-down"></i>
                </button>
                <button 
                  type="button" 
                  class="btn btn-sm arrow-btn"
                  (click)="moveBehaviorToBottom(behavior.ID!)"
                  [disabled]="isLastBehavior(behavior.ID!)"
                  title="Move to bottom">
                  <i class="pi pi-angle-double-down"></i>
                </button>
              </div>
            </div>
          </div>
        </td>
      </tr>
      } @else {
      <!-- Normal mode -->
      <app-behavior
        [behavior]="behavior"
        [id]="behavior.PatientBehaviorName"
        [isExpanded]="isExpandedStatus[behavior.ID]"
        (isExpandedChange)="onBehaviorExpandedChange(behavior.ID, $event)"
        [orderMode]="orderMode()"
        [isEditMode]="isEditMode()"
        (moveUp)="moveBehaviorUp($event)"
        (moveDown)="moveBehaviorDown($event)"
        (moveToTop)="moveBehaviorToTop($event)"
        (moveToBottom)="moveBehaviorToBottom($event)"
        [isSelecting]="selectingForDeletion"
        [selectAll]="doSelectAll"
        (selectBehavior)="selectBehavior($event)"
      />
      }
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <p
        style="
          text-align: center;
          margin-top: 20px;
          font-size: 1rem;
          color: #719eb6;
        "
      >
        There are no Behaviors yet.
      </p>
    </ng-template>
  </p-table>
</div>
